// extracted by mini-css-extract-plugin
module.exports = {"title":"AboutCancellation_title__2vQrW","responses":"AboutCancellation_responses__gCakA","selectRequester":"AboutCancellation_selectRequester__33gt_"};